import React from 'react';

const Addnewrepo_mysql = () => {
    return <div>this is my sql</div>;
};

export default Addnewrepo_mysql;
